<bs-digital-over-ask-summary-errors *ngIf="props.hasOfferChanges"></bs-digital-over-ask-summary-errors>
<div class="betslip-over-ask-summary-changes" *ngIf="shouldShowChanges">
    <div class="betslip-over-ask-summary-new-odds" *ngIf="hasOddsChange">
        <label>{{ messages.newOdds }}</label>
        <div>
            <span class="betslip-over-ask-summary-changes-old-value">{{ vm.original.totalOdds | bsOddsFormatter: oddsDisplayFormat }}</span>
            <span class="betslip-over-ask-summary-changes-new-value">{{ vm.offer.totalOdds | bsOddsFormatter: oddsDisplayFormat }}</span>
        </div>
    </div>
    <div class="betslip-over-ask-summary-new-stake" *ngIf="hasStakeChange">
        <label>{{ messages.newStake }}</label>
        <div>
            <span class="betslip-over-ask-summary-changes-old-value"
                ><ng-container *ngIf="oldMarketTypeText">{{ oldMarketTypeText }}&nbsp;</ng-container>{{ vm.original.totalStake | bsCurrency }}</span
            >
            <span class="betslip-over-ask-summary-changes-new-eachway-value" *ngIf="marketTypeOffer">{{ marketTypeOfferText }}</span>
            <span class="betslip-over-ask-summary-changes-new-value">{{ vm.offer.totalStake | bsCurrency: true }}</span>
        </div>
    </div>
</div>
<div class="betslip-over-ask-summary-items">
    <div class="betslip-over-ask-summary__item" *ngIf="!hasStakeChange">
        <span class="betslip-over-ask-summary__label">
            <ng-container *ngIf="!isMultiBet">{{ messages.stakeLabel }}</ng-container>
            <ng-container *ngIf="isMultiBet">{{ messages.totalStakeLabel }}</ng-container>
        </span>
        <span class="betslip-over-ask-summary__value">{{ vm.offer.totalStake | bsCurrency: true }}</span>
    </div>
    <div class="betslip-over-ask-summary__item" *ngIf="!hasOddsChange && vm.offer.totalOdds">
        <span class="betslip-over-ask-summary__label">{{ messages.totalOddsLabel }}</span>
        <span class="betslip-over-ask-summary__value">{{ vm.offer.totalOdds | bsOddsFormatter: oddsDisplayFormat }}</span>
    </div>
    <div class="betslip-over-ask-summary__item">
        <span class="betslip-over-ask-summary__label">{{ hasTax ? messages.netMaxReturnLabel : messages.maxReturnLabel }}</span>
        <span class="theme-info betslip-over-ask-summary__info-icon" *ngIf="hasTax" (click)="winsInfoClick()"></span>
        <span class="betslip-over-ask-summary__value">{{ (hasTax ? vm.offer.maxReturnNet : vm.offer.maxReturn) | bsCurrency: true }}</span>
    </div>
    <bs-digital-taxation-info [vm]="provideTaxationViewModel()" [(isVisible)]="isInfoVisible"></bs-digital-taxation-info>
</div>
<div class="betslip-over-ask-summary-action-container">
    <div class="betslip-over-ask-cancel-button">
        <button ds-button kind="secondary" variant="outline" size="large" truncate="true" (click)="cancelOverAsk()">
            {{ messages.cancelButtonTitle }}
        </button>
    </div>
    <bs-digital-over-ask-place-bet-button [props]="props"></bs-digital-over-ask-place-bet-button>
</div>
